<template>
  <section
    id="screenshots1"
    class="hide-overflow"
  >
    <v-layout row wrap>
      <v-flex
        xs12
        md6
      >
        <v-img
          src="/img/guest/1.jpg"
        />
      </v-flex>

      <v-flex
        xs12
        md6
        align-content-space-between
        layout
        pa-5
        wrap
      >
        <v-layout
          align-center
          justify-center
          fill-height
        >
          <v-flex
            xs10
            md6
          >
            <h2 class="v-heading mb-2 font-weight-medium">No Water:</h2>
            <p>
              For days and weeks the sledge dogs have to survive without fresh water. During my first visit to East Greenland I saw dogs that went crazy due to thirst.
            </p>
          </v-flex>
        </v-layout>

      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex
        xs12
        md6
        order-md2
        order-lg2
        order-xl2
      >
        <v-img
          src="/img/guest/2.jpg"
        />
      </v-flex>

      <v-flex
        xs12
        md6
        align-content-space-between
        layout
        pa-5
        wrap
        order-md1
        order-lg1
        order-xl1
      >
        <v-layout
          align-center
          justify-center
          fill-height
        >
          <v-flex
            xs10
            md6
          >
            <h2 class="v-heading mb-2 font-weight-medium">No Food:</h2>
            <p>
              It is getting more and more difficult for owners to feed their dogs properly. Sometimes the money for boat fuel is missing to go hunting in the summer.
            </p>
          </v-flex>
        </v-layout>

      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex
        xs12
        md6
      >
        <v-img
          src="/img/guest/3.jpg"
        />
      </v-flex>

      <v-flex
        xs12
        md6
        align-content-space-between
        layout
        pa-5
        wrap
      >
        <v-layout
          align-center
          justify-center
          fill-height
        >
          <v-flex
            xs10
            md6
          >
            <h2 class="v-heading mb-2 font-weight-medium">No shelter:</h2>
            <p>
              The dogs are kept without shelter. While mothers are chained, puppies search for cover, get trapped and die helplessly.
            </p>
          </v-flex>
        </v-layout>

      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex
        xs12
        md6
        order-md2
        order-lg2
        order-xl2
      >
        <v-img
          src="/img/guest/4.jpg"
        />
      </v-flex>

      <v-flex
        xs12
        md6
        align-content-space-between
        layout
        pa-5
        wrap
        order-md1
        order-lg1
        order-xl1
      >
        <v-layout
          align-center
          justify-center
          fill-height
        >
          <v-flex
            xs10
            md6
          >
            <h2 class="v-heading mb-2 font-weight-medium">No Vet:</h2>
            <p>
              Unbelieveable but true: for whole Estern Greenland is no Vet available. This is against the law. Nobody cares. Except Robin Hood.
            </p>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
  export default {
    name: 'GuestScreenshots',
  };
</script>

<style scoped>

</style>
